import { render, staticRenderFns } from "./ThankYouDeclined.vue?vue&type=template&id=7a6a2a80&scoped=true&"
import script from "./ThankYouDeclined.vue?vue&type=script&lang=js&"
export * from "./ThankYouDeclined.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouDeclined.vue?vue&type=style&index=0&id=7a6a2a80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6a2a80",
  null
  
)

export default component.exports